/**
 * Kreate.love — umbrella landing app root.
 *
 * Simple top-level routing. Only the landing page is wired in this
 * scaffold; the real marketing content will be built in a follow-up
 * pass.
 */
import React, { Suspense, lazy } from 'react';
import { Routes, Route, Navigate } from 'react-router-dom';

const LandingPage = lazy(() =>
  import('./pages/landing').then((m) => ({ default: m.LandingPage })),
);

const Fallback: React.FC = () => (
  <div className="min-h-screen flex items-center justify-center bg-background">
    <p className="text-sm text-muted-foreground">Loading…</p>
  </div>
);

const App: React.FC = () => (
  <div className="min-h-screen bg-background text-foreground" data-theme="kloutforce">
    <Suspense fallback={<Fallback />}>
      <Routes>
        <Route path="/" element={<LandingPage />} />
        <Route path="*" element={<Navigate to="/" replace />} />
      </Routes>
    </Suspense>
  </div>
);

export default App;